import * as Sentry from '@sentry/browser'

import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BrowserRouter, Route, Switch, withRouter } from 'react-router-dom'

import Home from './screens/Home'

Sentry.init({
  dsn: 'https://6899f3103d8d422d96b97b440484b7ce@sentry.io/1335034',
})

class App extends Component {
  render() {
    return (
      <React.Fragment>
        <div>
          <BrowserRouter basename="/scoreboard">
            <Switch>
              <Route path="/:port" render={Home} />
              <Route render={() => <div>Miss</div>} />
            </Switch>
          </BrowserRouter>
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(App)
)
